import React, {useState, useEffect} from 'react';
import MediumCard from './blogcard';
import FadeIn from 'react-fade-in';

import { NotMobile } from '../../../utils';
import { makeStyles } from "@material-ui/styles";

const styles = makeStyles((theme) => ({
    articlesContainer: {
      padding: theme.spacing(4),
      display: "flex",
      flexDirection: "column",
      alignItems: "center"
    },
    paragraph: {
      textAlign: "left",
    },
    spacer: {
      padding: theme.spacing(2),
      width: "100%",
    },
    row: {
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        justifyContent: "center",
        width: "100%"
    },
    buffer: {
        margin: "15px"
    },
    "@media (max-width: 767px)": {
        articlesContainer: {
            paddingTop: "50px"
        }
    }
  }));



export default function Articles() {
    const [itemRows, setItemRows] = useState([])
    const [avatar, setAvatar] = useState(null);
    const [profileLink, setProfileLink] = useState("");
    
    const classes = styles();

    const mediumURL = 'https://api.rss2json.com/v1/api.json?rss_url=https://medium.com/feed/@Lifeshack';

    useEffect(()=> {
        fetch(mediumURL)
            .then(res => res.json())
            .then(data => {
            // create two-dimensional array with 3 elements per inner array
            const currentAvatar = data.feed.image;
            const currentProfileLink = data.feed.link;
            const res = data.items; //This is an array with the content. No feed, no info about author etc..
            const posts = res.filter(item => item.categories.length > 0);

            setAvatar(currentAvatar);
            setProfileLink(currentProfileLink);

            const rows = [];
            posts.forEach((item, i) => {
                item['avatar'] = currentAvatar 
                item['profilelink'] = currentProfileLink 
                const row = Math.floor(i / 3);
                if (!rows[row]) rows[row] = [];
                rows[row].push(item);
            });

            setItemRows(rows)
        });
    }, [])

    const renderBlanks = (row) => {

        let numToRender = 3 - row.length;

        let res = [];

        for(let i = 0; i < numToRender; i++) {
            res.push((
                <NotMobile>
                    <div className={classes.buffer}>
                        <MediumCard blank />
                    </div>
                </NotMobile>
            ))
        }

        return res;
    }

    return (
        <div className={classes.articlesContainer}>
        {
            itemRows.map((row, i) => (
                <div className={classes.row} key={i}>
                { row.map((item, j) =>
                    <div className={classes.buffer}>
                        <FadeIn>
                            <MediumCard {...item} />
                        </FadeIn>
                    </div>
                )}
                {renderBlanks(row)}
                </div>
            ))
        }
        </div>
    );

}


